"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var css_1 = require("@emotion/css");
var react_1 = __importStar(require("react"));
var uniqueId_1 = __importDefault(require("lodash/uniqueId"));
function Animation(props) {
    var children = props.children, _a = props.duration, duration = _a === void 0 ? 1000 : _a, _b = props.delay, delay = _b === void 0 ? 0 : _b, persist = props.persist, transitionProperty = props.transitionProperty, _c = props.transitionTimingFunction, transitionTimingFunction = _c === void 0 ? 'ease' : _c, start = props.start, end = props.end, _d = props.intersectionThreshold, intersectionThreshold = _d === void 0 ? 0 : _d;
    var key = (0, react_1.useState)((0, uniqueId_1.default)('animation-'))[0];
    var _e = (0, react_1.useState)(false), isInView = _e[0], setIsInView = _e[1];
    (0, react_1.useEffect)(function () {
        var element = document.getElementsByClassName(key)[0];
        if (!element || typeof IntersectionObserver === 'undefined') {
            // check if IntersectionObserver is defined, if not just show animation
            return setIsInView(true);
        }
        var options = {
            threshold: intersectionThreshold
        };
        var observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
                // in the view
                setTimeout(function () {
                    setIsInView(true);
                }, delay * 1000);
                // disconnect observer if animation is only needed once
                if (!persist) {
                    observer === null || observer === void 0 ? void 0 : observer.disconnect();
                }
            }
            else {
                // no delay for animation out
                setIsInView(false);
            }
        }, options);
        observer.observe(element);
        return function () {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [delay, persist, intersectionThreshold, key]);
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.Children.map(children, function (child) {
        if (!child)
            return null;
        return react_1.default.cloneElement(child, {
            className: (0, css_1.cx)(key, 
            // eslint-disable-next-line
            child.props.className, (0, css_1.css)({
                transitionProperty: transitionProperty,
                // backward compatible with seconds
                transitionDuration: duration <= 5 ? duration + "s" : duration + "ms",
                transitionTimingFunction: transitionTimingFunction,
            }), (0, css_1.css)(start), 
            // trigger animation
            isInView ? (0, css_1.css)(end) : null),
        });
    })));
}
exports.default = Animation;
